/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import StarRating from '../../../../shared/components/StarRating/StarRating';


const RatingAttr = function RatingAttrComponent({ value }) {
  const hasRatings = value.count && value.value;

  return (
    <div className="product-table__rating">
      { hasRatings ? <StarRating {...value} /> : '-'}
    </div>
  );
};

RatingAttr.propTypes = {
  value: PropTypes.shape({}).isRequired,
  url: PropTypes.string,
};

RatingAttr.defaultProps = {
  url: null,
};


export default RatingAttr;
